/**
 * Created by AlexanderC on 6/10/15.
 */

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Instance = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _deepCore = require('deep-core');

var _deepCore2 = _interopRequireDefault(_deepCore);

var _Injectable = require('./Injectable');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Microservice instance class
 */
let Instance = exports.Instance = function () {
  /**
   * @param {String} identifier
   * @param {Object} rawResources
   * @param {Object} parameters
   */
  function Instance(identifier, rawResources) {
    let parameters = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    _classCallCheck(this, Instance);

    this._isRoot = false;
    this._rawResources = rawResources;
    this._identifier = identifier;
    this._parameters = parameters;
  }

  /**
   * @param {Object} globalConfig
   * @returns {Instance[]}
   */


  _createClass(Instance, [{
    key: 'inject',


    /**
     * @param {Object} objectInstance
     * @return {Object}
     */
    value: function inject(objectInstance) {
      if (!(objectInstance instanceof _Injectable.Injectable)) {
        throw new _deepCore2.default.Exception.InvalidArgumentException(objectInstance, 'deep-kernel.Injectable');
      }

      objectInstance.microservice = this;

      return objectInstance;
    }

    /**
     * @returns {String}
     */

  }, {
    key: 'toString',
    value: function toString() {
      return this._identifier;
    }

    /**
     * @returns {Object}
     */

  }, {
    key: 'parameters',
    get: function get() {
      return this._parameters;
    }

    /**
     * @returns {Object}
     */

  }, {
    key: 'rawResources',
    get: function get() {
      return this._rawResources;
    }

    /**
     * @returns {String}
     */

  }, {
    key: 'identifier',
    get: function get() {
      return this._identifier;
    }

    /**
     * @param {Boolean} state
     */

  }, {
    key: 'isRoot',
    set: function set(state) {
      this._isRoot = state;
    }

    /**
     * @returns {Boolean}
     */
    ,
    get: function get() {
      return this._isRoot;
    }
  }], [{
    key: 'createVector',
    value: function createVector(globalConfig) {
      let vector = [];

      for (let identifier in globalConfig.microservices) {
        if (!globalConfig.microservices.hasOwnProperty(identifier)) {
          continue;
        }

        let microservice = globalConfig.microservices[identifier];

        let microserviceObject = new Instance(identifier, microservice.resources, microservice.parameters || {});

        microserviceObject.isRoot = microservice.isRoot;

        vector.push(microserviceObject);
      }

      return vector;
    }
  }]);

  return Instance;
}();


//////////////////
// WEBPACK FOOTER
// ../~/deep-kernel/lib.compiled/Microservice/Instance.js
// module id = 174
// module chunks = 0